var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInvoices = function SvgInvoices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6 19.6V.4h9.506c.059 0 .114.03.146.078a18.759 18.759 0 0 0 5.203 5.203.176.176 0 0 1 .078.146V19.6H2.6Zm3.733-4.802a43.04 43.04 0 0 0 7.467 0v1.532c-.623-.065-1.244-.1-1.867-.122-1.866-.06-3.736-.056-5.6.122V14.8Zm7.467-3.531a43.02 43.02 0 0 1-7.467 0v1.531c1.864-.178 3.734-.181 5.6-.122.623.023 1.244.057 1.867.122v-1.531Z"
  })));
};
export default SvgInvoices;